import { useTranslation } from 'react-i18next';
import SVGIcon from '~/components/ui/Icons/SVGIcon';

type OfficeAvailabilityBannerProps = {
  extraClasses?: string;
};

const OfficeAvailabilityBanner = ({ extraClasses = '' }: OfficeAvailabilityBannerProps) => {
  const { t } = useTranslation();
  return (
    <div className={`w-100 bg-warning-100 py-3 fo-border-bottom-sm border-warning-500 ${extraClasses}`}>
      <div className="fixed-container-md container d-flex">
        <SVGIcon
          fill="#BF8226"
          iconType="alert-circle"
          className="me-2"
        />
        <div className="d-flex flex-column flex-md-row">
          <p className="text-1 -semibold color-warning-600 me-md-1">{t('office.show.unpublishedWarning.title')}</p>
          <p className="text-1 -regular color-warning-600">{t('office.show.unpublishedWarning.text')}</p>
        </div>
      </div>
    </div>
  );
};

export default OfficeAvailabilityBanner;
